import { render } from "./AdminSections.vue?vue&type=template&id=92c9cf4c"
import script from "./AdminSections.vue?vue&type=script&lang=js"
export * from "./AdminSections.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__